module.exports = __webpack_public_path__ + "img/finance-application-display-infiniti.41a2f552.png";